import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    ClientsWorkOverviewView,
    ClientsWorkOverviewColumn,
} from "@common/types/views/clientsWorkOverviewView";

/** The Applications drawer's columns until the user saves their own. */
export const DEFAULT_APPLICATIONS_DRAWER_VIEW: ClientsWorkOverviewView = {
    type: ViewType.CLIENTS_WORK_OVERVIEW,
    columns: [
        { id: ClientsWorkOverviewColumn.CLIENT, options: { pin: "left" } },
        { id: ClientsWorkOverviewColumn.ENTITY },
        { id: ClientsWorkOverviewColumn.SERVICE_PERIOD },
        { id: ClientsWorkOverviewColumn.WORK_START_DATE },
        { id: ClientsWorkOverviewColumn.WORK_DELIVERY_DATE },
        { id: ClientsWorkOverviewColumn.CLOSE_STAGE },
        { id: ClientsWorkOverviewColumn.TIME_IN_STAGE },
        { id: ClientsWorkOverviewColumn.PREPARER_REVIEWER },
        { id: ClientsWorkOverviewColumn.TASK_PROGRESS },
        { id: ClientsWorkOverviewColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
        density: ViewDensity.MD,
    },
};
